import { refreshSlider, breakSettings } from "@grindex-client/components/Slider/slider";

function init() {
	const initProductCarousel = () => {
		const $sliders = document.querySelectorAll(".cardSlider");

		$sliders.forEach(($slider) => {
			$($slider).bxSlider({
				breaks: breakSettings.smallCardBreakSettings,
				pager: false,
				slideMargin: 20,
				pause: 5000,
				autoReload: false,
				useCSS: false,
				onSliderRedraw: () => {
					refreshSlider($slider);
				},
			});
		});
	};

	initProductCarousel();
}

export default {
	view: "blogDetailPage",
	init,
};
